import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContexte';
import { useAccess } from '../../contexts/AccessContext';

/**
 * Réserve une route au propriétaire et aux Administrateurs Site (bouton Admin).
 * Redirige vers /welcome si l'utilisateur n'est pas autorisé.
 */
const SuperAdminRoute = ({ children }) => {
    const { token, loading: authLoading } = useAuth();
    const { isSiteAdmin, loading: accessLoading } = useAccess();

    if (authLoading || (token && accessLoading)) {
        return (
            <main className="c2-page admin-loading">
                <div className="c2-spinner" />
            </main>
        );
    }

    if (!token) return <Navigate to="/" replace />;
    if (!isSiteAdmin) return <Navigate to="/welcome" replace />;

    return children;
};

export default SuperAdminRoute;
